// eslint-disable-next-line import/no-mutable-exports -- we need to change this value for some apps
let redirectOn401 = true;

export const setRedirectOn401 = (value: boolean) => {
  redirectOn401 = value;
};

export { redirectOn401 };
